'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _es6Promise = _interopRequireDefault(require("es6-promise"));

var _dashboardUncheckedFarmList = _interopRequireDefault(require("../dashboard-unchecked-farm-list"));

var _dashboardOpenMembershipFeeList = _interopRequireDefault(require("../dashboard-open-membership-fee-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

_es6Promise.default.polyfill();

var CantonResponsibleDashboard = /*#__PURE__*/function (_React$Component) {
  _inherits(CantonResponsibleDashboard, _React$Component);

  function CantonResponsibleDashboard(props) {
    var _this;

    _classCallCheck(this, CantonResponsibleDashboard);

    _this = _possibleConstructorReturn(this, (CantonResponsibleDashboard.__proto__ || Object.getPrototypeOf(CantonResponsibleDashboard)).call(this, props));
    _this.state = {
      listsConfig: {
        openMembershipFee: {
          label: props.t('Offene Mitgliederbeiträge'),
          anchor: 'open-membership-fee-list',
          visible: true
        },
        uncheckedFarm: {
          label: props.t('Nicht geprüfte Hofdaten'),
          anchor: 'unchecked-farm-list',
          visible: true
        }
      }
    };
    _this.initSubMenu = _this.initSubMenu.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CantonResponsibleDashboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initSubMenu();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          history = _this$props.history,
          i18n = _this$props.i18n;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-canton-responsible-dashboard'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'open-membership-fee-list'
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.state.listsConfig.openMembershipFee.anchor
      }, this.state.listsConfig.openMembershipFee.label), /*#__PURE__*/_react.default.createElement(_dashboardOpenMembershipFeeList.default, {
        t: t,
        history: history,
        i18n: i18n
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: 'unchecked-farm-list'
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.state.listsConfig.uncheckedFarm.anchor
      }, this.state.listsConfig.uncheckedFarm.label), /*#__PURE__*/_react.default.createElement(_dashboardUncheckedFarmList.default, {
        t: t,
        history: history,
        i18n: i18n
      })));
    }
  }, {
    key: "initSubMenu",
    value: function initSubMenu() {
      var _this2 = this;

      if (this.props.getSubMenuConfig) {
        var config = Object.keys(this.state.listsConfig).filter(function (key) {
          return _this2.state.listsConfig[key].visible;
        }).map(function (key) {
          return _this2.state.listsConfig[key];
        });
        this.props.getSubMenuConfig(config);
      }
    }
  }]);

  return CantonResponsibleDashboard;
}(_react.default.Component);

CantonResponsibleDashboard.propTypes = {
  t: _propTypes.default.func.isRequired,
  history: _propTypes.default.object.isRequired,
  i18n: _propTypes.default.object.isRequired,
  getSubMenuConfig: _propTypes.default.func
};
var _default = CantonResponsibleDashboard;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/dashboard/canton-responsible-dashboard.js
// module id = 755
// module chunks = 0